// extracted by mini-css-extract-plugin
export default {"list":"dywoe","item":"liVou","img":"z0YjS"};